export const evaluation = {
    labels: {
        pending_analysis: "Pending Analyses",
        concluded_analysis: "Concluded Analyses",
        started_analysis: "Started Analyses",
        in_progress: "In Progress",
        started: "Started",
        pending: "Pending",
        concluded: "Concluded",
        canceled: "Canceled",
        all: "Show All",
        period: "Period",
        start: "Start",
        start_forecast: "Forecast Start",
        termination: "Forecast End",
    },
    modal: {
        titles: {
            add_analysis: "Add Analysis",
            add_company: "Add Company",
            add_evaluation: "Add Evaluation",
            start_evaluation: "Start Evaluation",
            cancel_evaluation: "Cancel Evaluation",
            finish_evaluation: "Finish Evaluation",
        },
        messages: {
            add_analysis: "Do you want to add an <strong>analysis</strong> to the evaluation?",
            add_company: "Do you want to add the company<br><strong>{concat}</strong><br>to the evaluation?",
            add_employee: "Do you want to add the employee<br><strong>{concat}</strong><br>to the evaluation?",
            add_evaluation: "Do you want to add a new Evaluation?",
            start_evaluation: "Do you want to <strong>START</strong> the Evaluation?<br>This action cannot be undone!",
            cancel_evaluation: "Do you want to <strong>CANCEL</strong> the Evaluation?<br>This action cannot be undone!",
            finish_evaluation: "Do you want to <strong>FINISH</strong> the Evaluation?<br>This action cannot be undone!",
        },
    },
    texts: {
        empty_evaluation: "There are no active evaluations to display."
    },
};
